<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <div class="d-flex flex-wrap justify-space-between align-center">
        <span class="h4 my-0">SOLICITUDES DE REVERSIÓN</span>

        <div class="d-flex flex-wrap align-center">
          <div>
            <v-pagination
              class="custom-pagination"
              v-model="pagina"
              :length="metadatos?.total_paginas"
              :total-visible="10"
              @input="listar"></v-pagination>
          </div>

          <div style="max-width: 150px">
            <v-select
              :items="[10, 25, 50, 75, 100]"
              label="Items por página"
              v-model="limite"
              outlined
              dense
              hide-details
              :disabled="items.length == 0"
              @change="cambiarPagina" />
          </div>
        </div>
      </div>
    </v-toolbar-title>

    <v-row dense>
      <v-col cols="12" sm="12" md="8" lg="6" xl="4">
        <div class="d-flex flex-wrap align-center" style="gap: 12px">
          <v-switch
            v-if="permisosPresupuestos2"
            style="margin-top: -4px"
            v-model="checkbox"
            hide-details
            label="Ver todas las sedes"></v-switch>

          <v-switch style="margin-top: -4px" v-model="expandirTodo" hide-details label="Expandir todo"></v-switch>

          <v-btn small class="mx-1" @click="listar">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3" xl="2">
        <v-menu
          ref="menuFechaDeDesembolso"
          v-model="menuFechaDeDesembolso"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="mesDesembolso"
              label="Mes de Desembolso"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              clearable
              hide-details
              v-bind="attrs"
              v-on="on"></v-text-field>
          </template>

          <v-date-picker
            v-model="mesDesembolso"
            no-title
            scrollable
            type="month"
            locale="es-ES"
            :max="fechaDeHoy().substring(0, 7)"
            @input="
              listarRestableciendoPagina();
              menuFechaDeDesembolso = false;
            ">
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3" xl="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="updateSearchQueryBack"></v-text-field>
      </v-col>

      <v-col cols="12">
        <ListadoSolicitudesParaComprobanteReversion
          :items="items"
          :cargando="cargando"
          :detallesCarritoIds="detallesCarritoIds"
          :cuentaDestinoCarrito="cuentaDestinoCarrito"
          :expandirTodo="expandirTodo"
          @toggleDetalle="toggleDetalle"
          @verComprobante="verComprobante" />
      </v-col>
    </v-row>

    <notifications group="notifications" position="top right" />

    <v-footer v-if="detallesCarrito.length > 0" fixed color="primary" dark class="carrito-footer pa-2">
      <div class="d-flex align-center flex-wrap" style="width: 100%; gap: 8px">
        <span class="body-2 mr-2">
          <strong>{{ detallesCarrito.length }}</strong> detalle(s) seleccionado(s)
        </span>
        <span class="body-2 mr-2">
          Cta. Destino: <strong>{{ cuentaDestinoCarrito }}</strong>
        </span>
        <span class="body-2 mr-auto">
          Total: <strong>Bs. {{ totalCarrito }}</strong>
        </span>
        <v-btn small text @click="limpiarCarrito">
          <v-icon small class="mr-1">mdi-delete</v-icon>
          Limpiar
        </v-btn>
        <v-btn small color="white" light @click="abrirModalComprobante">
          <v-icon small color="primary" class="mr-1">mdi-receipt</v-icon>
          <span class="primary--text">Registrar Comprobante</span>
        </v-btn>
      </div>
    </v-footer>

    <ModalRegistrarComprobanteReversion ref="modalComprobanteRef" @guardado="onComprobanteGuardado" />
    <ModalVerComprobanteReversion ref="modalVerComprobanteRef" />
  </div>
</template>

<script>
import solicitudRecursosMixin from '../mixins/solicitud-recursos-mixin';
import moment from 'moment';
import { ESTADOS_DETALLE_SOLICITUD, TIPOS_SOLICITUD } from '../utils';
import ListadoSolicitudesParaComprobanteReversion from '../components/ListadoSolicitudesParaComprobanteReversion.vue';
import ModalRegistrarComprobanteReversion from '../components/ModalRegistrarComprobanteReversion.vue';
import ModalVerComprobanteReversion from '../components/ModalVerComprobanteReversion.vue';

export default {
  name: 'SolicitudesReversion',
  mixins: [solicitudRecursosMixin],
  components: {
    ListadoSolicitudesParaComprobanteReversion,
    ModalRegistrarComprobanteReversion,
    ModalVerComprobanteReversion,
  },
  data() {
    return {
      checkbox: false,
      expandirTodo: localStorage.getItem('solicitudesReversion.expandirTodo') === 'true',
      tipo: TIPOS_SOLICITUD.RECURSOS,
      estadosSeleccionadosDetalleSolicitud: [ESTADOS_DETALLE_SOLICITUD.REVERSION],
      mesDesembolso: new Date().toISOString().substring(0, 7),
      detallesCarrito: [],
    };
  },
  computed: {
    detallesCarritoIds() {
      return new Set(this.detallesCarrito.map((d) => d.id));
    },
    cuentaDestinoCarrito() {
      return this.detallesCarrito[0]?.cuenta_destino || null;
    },
    totalCarrito() {
      return this.detallesCarrito.reduce((s, d) => s + Number(d.importe || 0), 0).toFixed(2);
    },
  },
  watch: {
    '$store.state.CARGO.sede.id'() {
      this.listarRestableciendoPagina();
    },
    checkbox() {
      this.listarRestableciendoPagina();
    },
    mesDesembolso(value) {
      if (!value) {
        this.listarRestableciendoPagina();
      }
    },
    expandirTodo(value) {
      localStorage.setItem('solicitudesReversion.expandirTodo', value);
    },
  },
  methods: {
    obtenerParametros() {
      return {
        tipo: this.tipo,
        estados_detalle_solicitud: this.estadosSeleccionadosDetalleSolicitud,
        fecha_inicio_reversion: moment(this.mesDesembolso).startOf('month').format('YYYY-MM-DD'),
        fecha_fin_reversion: moment(this.mesDesembolso).endOf('month').format('YYYY-MM-DD'),
        sede_origen_id: this.checkbox ? null : this.$store.state.CARGO.sede.id,
        limite: this.limite,
        pagina: this.pagina,
        buscar: this.searchQuery,
      };
    },
    async listar() {
      const params = this.obtenerParametros();
      await this.listarMixin(params);
    },
    toggleDetalle(detalle) {
      const idx = this.detallesCarrito.findIndex((d) => d.id === detalle.id);
      if (idx === -1) {
        this.detallesCarrito.push(detalle);
      } else {
        this.detallesCarrito.splice(idx, 1);
      }
    },
    limpiarCarrito() {
      this.detallesCarrito = [];
    },
    abrirModalComprobante() {
      this.$refs.modalComprobanteRef.abrir(this.detallesCarrito);
    },
    onComprobanteGuardado() {
      this.detallesCarrito = [];
      this.listar();
    },
    verComprobante({ comprobanteReversionId, detalleId }) {
      this.$refs.modalVerComprobanteRef.abrir(comprobanteReversionId, detalleId);
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-btn:not(.v-btn--round).v-size--small {
  min-width: 40px;
  padding: 0 6px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}
::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}
::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}

.carrito-footer {
  bottom: 0;
  z-index: 10;
}

/* v-date-picker */
::v-deep .accent {
  background-color: #005caf !important;
  border-color: #005caf !important;
}
</style>
